import { useSuspenseQuery } from '@/hooks/use-suspense-query';

import { teamApi } from './team-api';

export function useOrganisationMembers(tenantId: string) {
  const { data, ...rest } = useSuspenseQuery(
    teamApi.getOrganizationMembers(tenantId),
  );

  return {
    data: data ?? [],
    ...rest,
  };
}

export function useOrganisationInvites(tenantId: string) {
  const { data, ...rest } = useSuspenseQuery(
    teamApi.getOrganizationInvites(tenantId),
  );

  return {
    data: data ?? [],
    ...rest,
  };
}

export function useUserInvites(email: string) {
  const { data, ...rest } = useSuspenseQuery(teamApi.getUserInvites(email));

  return {
    data: data ?? [],
    ...rest,
  };
}
